import React from 'react';
import Spinner, {SpinnerProps} from 'react-bootstrap/Spinner';

import './index.scss';

const LoadingSpinner: React.FC<SpinnerProps> = (props) => {
	return (
		<div className={'spinner-container'}>
			<Spinner {...props} />
		</div>
	);
};

export default LoadingSpinner;
